import { RATING_QUAL_NUM } from "utils/Constants";
import { StringIndexType } from "utils/Types";

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const deepEqual = (object1: any, object2: any): boolean => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
      return false;
    }
  }

  return true;
};

const isObject = (object: any) => {
  return object != null && typeof object === "object";
};

export const compareArrays = (array1: string[], array2: string[]): boolean => {
  if (array1.length != array2.length) {
    return false;
  }
  const array1ToSort = [...array1];
  const array2ToSort = [...array2];
  array1ToSort.sort();
  array2ToSort.sort();

  return array1ToSort.every((val, index) => val === array2ToSort[index]);
};

export const isObjEmpty = (obj: any): boolean => Object.keys(obj).length === 0;

export const excludeEmptyObj = (obj: any) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === undefined || obj[key].length < 1) {
      delete obj[key];
    }
  });
  return obj;
};

export const convertRatingObjToArray = (obj: any) => {
  if (obj) {
    const ratingArray: any[] = [];
    Object.keys(obj).map(key => {
      if (obj[key]) {
        ratingArray.push({
          levelOfQual: key,
          rating: obj[key]
        });
      }
    });

    return ratingArray;
  } else {
    return;
  }
};

export const convertRatingArrayToObj = (array: any[]) => {
  if (array) {
    const ratingObj: StringIndexType = {};
    array.forEach(e => {
      const propName: string = e.levelOfQual;
      if (e.rating) {
        ratingObj[propName] = e.rating;
      }
    });

    return ratingObj;
  } else {
    return {};
  }
};

export const checkAllSelected = (obj: any) => {
  const objLength = Object.keys(obj).filter(key => key !== "comment").length;
  return objLength === RATING_QUAL_NUM;
};
